export default {
  state: {
    sys_name: 'A-Level-CIE',
    subjects: [
      {
        name: 'Mathematics',
        icon: 'mdi-function-variant'
      },{
        name: 'Further Mathematics',
        icon: 'mdi-function-variant'
      },{
        name: 'Physics',
        icon: 'mdi-electron-framework'
      },{
        name: 'Chemistry',
        icon: 'mdi-flask'
      },{ 
        name: 'Biology', 
        icon: 'mdi-leaf' 
      },{ 
        name: 'Computer Science', 
        icon: 'mdi-web' 
      },{ 
        name: 'Economics', 
        icon: 'mdi-piggy-bank-outline' 
      },
    ]
  }
}
